import { QueryClient, useMutation } from '@tanstack/react-query';
import axios from 'axios';

import { EVENT_BY_ID_QUERY_KEY, STREAM_EVENT_API_URL } from '@/constants';
import { apiUrl } from '@/helpers';
import {
  ErrorResponse,
  Options,
  StreamEventPayload,
  UpdateStreamEventPayload,
  UpdateStreamStatus
} from '@/types';

export const streamEventEndpoints = {
  createStreamEvent: (payload: StreamEventPayload) =>
    axios.post(`${apiUrl()}${STREAM_EVENT_API_URL}`, payload),
  updateStreamEvent: (payload: UpdateStreamEventPayload) =>
    axios.put(`${apiUrl()}${STREAM_EVENT_API_URL}/${payload.id}`, payload),
  updateStreamStatus: (streamEventId: number, payload: UpdateStreamStatus) =>
    axios.put(`${apiUrl()}${STREAM_EVENT_API_URL}/updateStreamEvent/${streamEventId}`, payload)
};

export const useCreateStreamEventMutation = (queryClient: QueryClient, options: Options) => {
  return useMutation(streamEventEndpoints.createStreamEvent, {
    onSuccess: (response) => {
      options.onSuccess(response);
      queryClient.invalidateQueries([EVENT_BY_ID_QUERY_KEY]);
    },
    onError: (error) => {
      options.onError(error as ErrorResponse);
    }
  });
};

export const useUpdateStreamEvent = (queryClient: QueryClient, options: Options) => {
  return useMutation(streamEventEndpoints.updateStreamEvent, {
    onSuccess: () => {
      options.onSuccess();
      queryClient.invalidateQueries([EVENT_BY_ID_QUERY_KEY]);
    },
    onError: (error) => {
      options.onError(error as ErrorResponse);
    }
  });
};

export const useUpdateStreamStatus = (queryClient: QueryClient, options: Options) => {
  return useMutation(
    ({ streamEventId, payload }: { streamEventId: number; payload: UpdateStreamStatus }) =>
      streamEventEndpoints.updateStreamStatus(streamEventId, payload),
    {
      onSuccess: () => {
        options.onSuccess();
        queryClient.invalidateQueries([EVENT_BY_ID_QUERY_KEY]);
      },
      onError: (error) => {
        options.onError(error as ErrorResponse);
      }
    }
  );
};
